import sliders from './slider';

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top + 80;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};
function initScrollAnimation(animatedObj) {
    animatedObj = $(animatedObj);

    animatedObj.each(function(id) {
        var $this = $(this);

        if ($this.isInViewport()) {
            $this.addClass('is-animated');
        }

        $(window).on('resize scroll', function() {
            if ($this.isInViewport()) {
                $this.addClass('is-animated');
            }
        });    
    });
}

function tabToAccordion(){
    setTimeout(function () {
        var tabItems = $('.tabs__tab-nav li > a');
        var wrap = $('<div />');
        wrap.addClass('tab-nav-select-wrap');

        var select = $('<select />');
        wrap.append(select);

        tabItems.each(function (i, el) {
            var opt = $('<option />');
            opt.val($(el).attr('href'));
            opt.text($(el).text());
            select.append(opt);
        });
        $('.tabs.tabs-only .wrapper').append(wrap);

        select.on('change', function () {
            var href = $(this).find('option:selected').val();
            console.log('tabs.js - 17', href);
        });
    }, 250);

    // tabs desktop
    $('body').on('click', '.tabs .tabs__tab-nav li a', function (event) {
        //
        event.preventDefault();
        if ($(window).width() < 960) return;
        var tabsOnly = $(this).parents('.tabs-single').length,
            parentLi = $(this).parent('li'),
            prevActiveLi = $('.tabs .tabs__tab-nav li.active'),
            tab = $($(this).data('tab')),
            prevActiveTab = $('.tabs .tabs__tab.active'),
            allBodies = $('.tabs .tabs__tab .tabs__body');

        setTimeout(function () {
            prevActiveLi.removeClass('active');
            parentLi.addClass('active');
            if (!tabsOnly) {
                prevActiveTab.removeClass('active');
            }
        }, 50);

        setTimeout(function () {
            if (!tabsOnly) {
                tab.addClass('active');
            }
        }, 50);


        setTimeout(function() {
            allBodies.addClass('is-animated');
        }, 250);
    });
    // /tabs desktop

    /* tabs mobile */
    $('body').on('click', '.tabs .tabs__tab .tabs__header a', function (e) {
        var allTabs = $('.tabs .tabs__tab'),
            allPlusMinus = $('.tabs .tabs__tab .plus-minus');

        e.preventDefault();
        allTabs.removeClass('active');
        allPlusMinus.removeClass('is-active');

        var currentTab = $(this).parents('.tabs__tab'),
            plusMinus = $(this).children('.plus-minus');

        currentTab.addClass('active');
        plusMinus.addClass('is-active');

        setTimeout(function() {
            $('html, body').animate({
                scrollTop: $('.tabs .tabs__tab').offset().top - 15
            }, 1000);
        }, 500)
    });
    $('body').on('click', '.tabs .tabs__tab.active .tabs__header a', function (e) {

        var currentTab = $(this).parents('.tabs__tab'),
            plusMinus = $(this).children('.plus-minus');

        currentTab.removeClass('active');
        plusMinus.removeClass('is-active');

        setTimeout(function() {
            $('html, body').animate({
                scrollTop: $('.tabs .tabs__tab').offset().top - 15
            }, 1000);
        }, 500)
    });
    /* /tabs mobile */
}

$(document).ready(function () {
    initScrollAnimation('.js-animated');
    tabToAccordion();
    if ($(document).width() < 960){
        $('.tabs .tabs__tab.active').removeClass('active');
    }
    if ($(document).width() > 959){
        $(".logo-carousel__items.owl-carousel").owlCarousel({
            items:3,
            dots:false,
            nav:true,
            navText:["&#10092;","&#10093;"],
            autoplay:false,
            loop:true,
            margin: 150,
            slideBy: 3
        })
    }
});



// WEBPACK FOOTER //
// ./src/js/app.js